/* eslint-disable max-len */
/* eslint-disable sort-keys */
export const remoteLabs = {
    titles: {
        agendarExame: 'Vamos agendar seus exames?',
        agendarVacina: 'Vamos agendar suas vacinas?',
        agendarConsulta: 'Vamos agendar sua consulta?',
        resultadoExame: 'Vamos consultar o resultado de seus exames?',
        default: 'Acesse ou crie uma conta',
    },
    subtitles: {
        default: 'Agende exames, consultas, vacinas e acompanhe seus resultados.',
    },
    laboratories: {
        alta: {
            name: 'Alta',
            image: 'https://nav.dasa.com.br/assets/logoLabs/alta.svg',
        },
        alvaro: {
            name: 'laboratório alvaro',
            image: 'https://nav.dasa.com.br/assets/logoLabs/alvaro.svg',
        },
        atalaia: {
            name: 'laboratório atalaia',
            image: 'https://nav.dasa.com.br/assets/logoLabs/atalaia.svg',
        },
        bronstein: {
            name: 'laboratório Bronstein',
            image: 'https://nav.dasa.com.br/assets/logoLabs/bronstein.svg',
        },
        cdpi: {
            name: 'laboratório CDPI',
            image: 'https://nav.dasa.com.br/assets/logoLabs/cdpi.svg',
        },
        cedilab: {
            name: 'laboratório Cedic Lab',
            image: 'https://nav.dasa.com.br/assets/logoLabs/cedilab.svg',
        },
        cerpe: {
            name: 'laboratório cerpe',
            image: 'https://nav.dasa.com.br/assets/logoLabs/cerpe.svg',
        },
        cytolab: {
            name: 'laboratório cytolab',
            image: 'https://nav.dasa.com.br/assets/logoLabs/cytolab.svg',
        },
        geneone: {
            name: ' laboratório dasa genomica',
            image: 'https://nav.dasa.com.br/assets/logoLabs/dasagenomica.svg',
        },
        delboni: {
            name: ' laboratório delboni',
            image: 'https://nav.dasa.com.br/assets/logoLabs/delboni.svg',
        },
        deliberato: {
            name: ' laboratório dasa deliberato',
            image: 'https://nav.dasa.com.br/assets/logoLabs/deliberato.svg',
        },
        exame: {
            name: 'laboratório Exame',
            image: 'https://nav.dasa.com.br/assets/logoLabs/exame.svg',
        },
        frischmann: {
            name: 'laboratório Frischmann',
            image: 'https://nav.dasa.com.br/assets/logoLabs/frischimann.svg',
        },
        gilsoncidrim: {
            name: 'laboratório dasa gilson',
            image: 'https://nav.dasa.com.br/assets/logoLabs/gilson.svg',
        },
        ghanem: {
            name: 'laboratório dasa ghanem',
            image: 'https://nav.dasa.com.br/assets/logoLabs/ghanem.svg',
        },
        imagememorial: {
            name: 'laboratório Image Memorial',
            image: 'https://nav.dasa.com.br/assets/logoLabs/imagemmemorial.svg',
        },
        itulab: {
            name: 'laboratório Jtu Lab',
            image: 'https://nav.dasa.com.br/assets/logoLabs/itulab.svg',
        },
        labpasteur: {
            name: 'laboratório Pasteur',
            image: 'https://nav.dasa.com.br/assets/logoLabs/labpasteur.svg',
        },
        laminasc: {
            name: 'laboratório Lâmina Diagnósticos',
            image: 'https://nav.dasa.com.br/assets/logoLabs/laminadiagnostico.svg',
            param: 'utm_medium',
        },
        lamina: {
            name: 'laboratório Lâmina Rio de Janeiro',
            image: 'https://nav.dasa.com.br/assets/logoLabs/laminarj.svg',
        },
        leme: {
            name: 'laboratório Leme',
            image: 'https://nav.dasa.com.br/assets/logoLabs/leme.svg',
        },
        lavoisier: {
            name: 'Lavoisier',
            title: 'Vamos agendar ou retirar seus exames?',
            titleBgColor: '#3295DB',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/logoLabs/lavoisier.svg',
        },
        hemat: {
            name: 'Hemat',
            title: 'Vamos consultar o resultado de seus exames?',
            titleBgColor: '#D61F26',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/logoLabs/hemat.svg',
        },
        gaspar: {
            name: 'Gaspar',
            title: 'Vamos consultar o resultado de seus exames?',
            titleBgColor: '#019E95',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/logoLabs/gaspar.svg',
        },
        bioclinico: {
            name: 'Bioclinico',
            title: 'Vamos consultar o resultado de seus exames?',
            titleBgColor: '#285CA6',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/logoLabs/bioclinico.svg',
        },
        hsp: {
            name: 'Hospital Santa Paula',
            title: 'Vamos agendar sua consulta?',
            titleBgColor: '#71A064',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/landingpage/santa-paula/logo.svg',
            param: 'hospital',
        },
        'nove-de-julho': {
            name: 'Hospital Nove de Julho',
            title: 'Vamos agendar sua consulta?',
            titleBgColor: '#33AF66',
            layout: 'brandEmphasis',
            image: 'https://nav.dasa.com.br/assets/landingpage/nove-de-julho/logo.svg',
            param: 'hospital',
        },
        oswaldocruz: {
            name: 'laboratório Oswaldo Cruz',
            image: 'https://nav.dasa.com.br/assets/logoLabs/oswaldocruz.svg',
        },
        padrao: {
            name: 'laboratório Padrão Ribeiro',
            image: 'https://nav.dasa.com.br/assets/logoLabs/padraoribeirao.svg',
        },
        previlab: {
            name: 'Laboratório PreVilaB',
            image: 'https://nav.dasa.com.br/assets/logoLabs/previlab.svg',
        },
        salomaoezoppi: {
            name: 'laboratório Salomão Zoppi',
            image: 'https://nav.dasa.com.br/assets/logoLabs/salomaoezoppi.svg',
        },
        sergiofranco: {
            name: 'laboratório Sérgio Franco ',
            image: 'https://nav.dasa.com.br/assets/logoLabs/sergiofranco.svg',
        },
        valeclin: {
            name: 'laboratório Vale Clin',
            image: 'https://nav.dasa.com.br/assets/logoLabs/valeclin.svg',
        },
        vitalbrasil: {
            name: 'laboratório Vital Brasil',
            image: 'https://nav.dasa.com.br/assets/logoLabs/vital.svg',
        },
        camiloac: {
            name: 'laboratório Grupo São Camilo',
            image: 'https://nav.dasa.com.br/assets/logoLabs/gruposaocamilo.svg',
        },
        camiloap: {
            name: 'laboratório Grupo São Camilo',
            image: 'https://nav.dasa.com.br/assets/logoLabs/gruposaocamilo.svg',
        },
        camilordi: {
            name: 'laboratório Grupo São Camilo',
            image: 'https://nav.dasa.com.br/assets/logoLabs/gruposaocamilo.svg',
        },
        hba: {
            name: 'Hospital da Bahia',
            image: 'https://nav.dasa.com.br/assets/logoLabs/hospitaldabahia.svg',
            param: 'hospital',
        },
        multiimagem: {
            name: 'Multi-Imagem Ressonância',
            image: 'https://nav.dasa.com.br/assets/logoLabs/multiimagem.svg',
            prefix: 'da',
        },
    },
}
